import { filterNames } from '@/billing/pages/BillingPage/constants'

export const filterTypes = [
  { label: 'Tipo factura', value: filterNames.type },
  { label: 'Estado factura', value: filterNames.status },
  { label: 'Fecha factura', value: filterNames.invoiceDates },
  { label: 'Fecha pago', value: filterNames.collectedDates },
]
